import React from 'react';
import { themeColors } from '../theme';
import { LoadingOutlined } from '@ant-design/icons';
import Patment from './../assets/payment.png';
import QpayLogo from './../assets/QPay.png';
import CybersourceLogo from './../assets/CyberSource-Logo.png';
import { Button, ConfigProvider, Radio } from 'antd';
import { SERVICETYPE } from '../services/Typecode';

const PaymentComponent = (props) => {
    const {
        paymentMode,
        setPaymentMode,
        placeOrder,
        translation,
        paymentLoader,
        isQpayEnabled,
        isCybersourceEnabled,
    } = props;
    const serviceType = localStorage.getItem(SERVICETYPE);
    const isDelivery = serviceType === 'delivery';

    const paymentOptions = [
        {
            value: 'CASH',
            label: isDelivery
                ? translation['by_cash']
                : translation['by_cash_pickup'],
        },
        {
            value: 'EDC',
            label: isDelivery
                ? translation['by_edc_machine']
                : translation['by_edc_machine_pickup'],
        },
    ];
    if (isQpayEnabled) {
        paymentOptions.push({
            value: 'QPAY',
            label: isDelivery
                ? translation['by_qpay']
                : translation['by_qpay_pickup'],
        });
    }
    if (isCybersourceEnabled) {
        paymentOptions.push({
            value: 'CYBERSOURCE',
            label: isDelivery
                ? translation['by_cybersource']
                : translation['by_cybersource_pickup'],
        });
    }

    return (
        <div className='flex flex-1 flex-col'>
            {/* Compact header */}
            <div className='flex flex-row items-center justify-center gap-x-2 mb-5'>
                <div className='flex items-center justify-center rounded-xl border-2 border-green-600 bg-white p-1.5 shadow-sm'>
                    <img
                        style={{ width: 26, height: 26, objectFit: 'contain' }}
                        alt='pay'
                        src={Patment}
                    />
                </div>
                <div className='text-sm font-bold text-gray-800'>
                    {translation['choose_payment']}
                </div>
            </div>

            {/* Selectable payment option cards */}
            <ConfigProvider
                theme={{ token: { colorPrimary: themeColors.primaryColor } }}
            >
                <Radio.Group
                    onChange={(e) => setPaymentMode(e.target.value)}
                    value={paymentMode}
                    className='flex flex-col gap-y-3 w-full'
                >
                    {paymentOptions.map((opt) => {
                        const isSelected = paymentMode === opt.value;
                        return (
                            <div
                                key={opt.value}
                                onClick={() => setPaymentMode(opt.value)}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    padding: '14px 16px',
                                    borderRadius: 16,
                                    cursor: 'pointer',
                                    border: `2px solid ${
                                        isSelected
                                            ? themeColors.primaryColor
                                            : '#e5e7eb'
                                    }`,
                                    backgroundColor: isSelected
                                        ? themeColors.bgColor(0.06)
                                        : '#ffffff',
                                    boxShadow: isSelected
                                        ? '0 2px 8px rgba(138, 92, 196, 0.12)'
                                        : 'none',
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <Radio value={opt.value} style={{ margin: 0 }}>
                                    <span
                                        className='text-sm font-medium'
                                        style={{
                                            color: isSelected
                                                ? themeColors.primaryColor
                                                : '#374151',
                                        }}
                                    >
                                        {opt.label}
                                    </span>
                                </Radio>
                                {opt.value === 'QPAY' && (
                                    <img
                                        src={QpayLogo}
                                        alt='QPay'
                                        style={{
                                            height: 22,
                                            objectFit: 'contain',
                                            marginInlineStart: 'auto',
                                        }}
                                    />
                                )}
                                {opt.value === 'CYBERSOURCE' && (
                                    <img
                                        src={CybersourceLogo}
                                        alt='CyberSource'
                                        style={{
                                            height: 22,
                                            objectFit: 'contain',
                                            marginInlineStart: 'auto',
                                        }}
                                    />
                                )}
                            </div>
                        );
                    })}
                </Radio.Group>
            </ConfigProvider>

            {/* Place order */}
            <Button
                style={{ backgroundColor: themeColors.primaryColor }}
                className='flex-row text-center rounded-full shadow-lg h-12 justify-center items-center gap-x-2 mt-6 border-none'
                onClick={placeOrder}
                disabled={paymentLoader}
            >
                {paymentLoader ? (
                    <LoadingOutlined style={{ color: '#fff' }} />
                ) : (
                    <div className='text-white text-md text-center'>
                        {translation['place_Order']}
                    </div>
                )}
            </Button>
            {paymentLoader && (
                <div className='text-gray-400 text-xs text-center mt-2'>
                    {translation['do_not_press_back_msg']}
                </div>
            )}
        </div>
    );
};

export default PaymentComponent;
